import { HTMLAttributes } from 'react';
import styles from './styles.module.scss';
import { joinClassNames } from '../../utils';

export type CollapsibleSectionProps = HTMLAttributes<HTMLDivElement> & {
  isCollapsed?: boolean;
};

export const CollapsibleSection = ({ children, isCollapsed }: CollapsibleSectionProps) => (
  <div className={joinClassNames(styles.collapsibleSection, isCollapsed && styles.isCollapsed)}>
    {children}
  </div>
);
